import React from 'react'

import styles from './styles.module.scss'

const ImageCaption = ({ props }) => {
    return (
        <span className={`heading-6 ${styles['image-caption']} ${styles[`image-caption--${props.caption_size}`]}`} style={{ textAlign: props.caption_align, margin: props.caption_align == 'center' ? '0 auto' : 'initial'  }}>{props.caption}</span>
    )
}

export default ImageCaption
